
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitchHorizontalOn as ObiSwitchHorizontalOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-horizontal-on.js';
 
 
 

 
 export const ObiSwitchHorizontalOn = createComponent({
   react: React,
   tagName: 'obi-switch-horizontal-on',
   elementClass: ObiSwitchHorizontalOnElement,
   events: {
     
   }
  });
 
 